"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Balloon_1 = require("./Balloon");
const Button_1 = require("./Button");
const flex_scss_1 = __importDefault(require("./styles/flex.scss"));
const footer_scss_1 = __importDefault(require("./styles/footer.scss"));
const dummy_assets_1 = require("./dummy-assets");
const FooterPane_1 = require("./FooterPane");
const store_1 = require("./store");
const Transition_1 = require("./Transition");
function Footer({}) {
    const [opened, setOpened] = React.useState(false);
    const close = React.useCallback(() => {
        setOpened(false);
    }, []);
    const [assets] = React.useState(dummy_assets_1.dummyAssets);
    const [search, setSearch] = React.useState('');
    return (React.createElement(React.Fragment, null,
        React.createElement(Transition_1.Transition, { in: opened, className: classnames_1.default(footer_scss_1.default.container, flex_scss_1.default.vertical), exiting: footer_scss_1.default.hidden },
            React.createElement(FooterPane_1.FooterPane, { assets: assets, onRequestClose: close, search: search })),
        React.createElement("div", { className: classnames_1.default(footer_scss_1.default.bar, opened && footer_scss_1.default.opened, flex_scss_1.default.horizontal) },
            React.createElement(Button_1.IconButton, { name: "search", className: footer_scss_1.default.search, onClick: () => setOpened(!opened) },
                React.createElement(Balloon_1.Balloon, { icon: "info", delay: 5000 }, "Add charactor to the game")),
            opened ? (React.createElement("input", { type: "text", autoFocus: true, placeholder: "Search monsters, people and items", value: search, onChange: e => setSearch(e.currentTarget.value) })) : (React.createElement(React.Fragment, null,
                React.createElement(FooterItem, null),
                React.createElement(FooterItem, null),
                React.createElement("div", { className: footer_scss_1.default.divider }),
                React.createElement(FooterItem, null),
                React.createElement(FooterItem, null),
                React.createElement(FooterItem, null),
                React.createElement(FooterItem, null),
                React.createElement(FooterItem, null),
                React.createElement(FooterItem, null))))));
}
exports.Footer = Footer;
function FooterItem({}) {
    const dispatch = react_redux_1.useDispatch();
    const onClick = React.useCallback(() => {
        dispatch(store_1.actions.setEditorMode(store_1.EditorMode.Code));
    }, []);
    return (React.createElement("button", { className: footer_scss_1.default.item, onClick: onClick },
        React.createElement("div", { style: { backgroundColor: 'blue' } })));
}
exports.FooterItem = FooterItem;
